import React from 'react';
import { Phase } from '../types';
import { ArrowRight } from 'lucide-react';

interface PhaseStepperProps {
  phases: API.PROJECTHQ.Stage[];
  currentPhase?: API.PROJECTHQ.Stage;
  onPhaseChange: (phase: API.PROJECTHQ.Stage) => void;
}

export const PhaseStepper: React.FC<PhaseStepperProps> = ({ phases, currentPhase, onPhaseChange }) => {
  return (
    <div className="bg-white shrink-0">
      <div className="">
        <div className="flex items-center justify-between min-w-max space-x-2">
          {phases.map((phase, index) => {
            const isActive = phase.ID === currentPhase?.ID;
            const isLast = index === phases.length - 1;

            return (
              <React.Fragment key={phase.ID}>
                <div className={`py-4 px-4 rounded-tl-xl rounded-tr-xl ${isActive ? 'bg-blue-100' : 'hover:bg-gray-50'}`}>
                  <div
                    onClick={() => onPhaseChange(phase)}
                    className={`
                    group flex items-center justify-center cursor-pointer px-4 py-2
                    ${isActive
                        ? 'border-0 border-b-2 border-solid border-primary'
                        : 'text-gray-500 hover:text-primary'}
                  `}
                  >
                    <span className="text-sm md:text-base whitespace-nowrap">{phase.name}</span>
                    {phase.uncompletedCount > 0 && (
                      <span className={`
                      flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs rounded-full ml-2
                      ${isActive ? 'bg-red-500 text-white' : 'border border-solid border-red-500 text-red-500'}
                    `}>
                        {phase.uncompletedCount}
                      </span>
                    )}
                  </div>
                </div>
                
                
                {!isLast && (
                  <div className="shrink-0 px-2 text-accent">
                     <ArrowRight size={20} strokeWidth={2.5} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};